export const extractErrorMessage = (error: unknown): string => {
  const detail = (error as { detail?: unknown } | null)?.detail;
  if (typeof detail === "string") {
    return detail;
  }
  if (Array.isArray(detail) && typeof detail[0]?.msg === "string") {
    return detail[0].msg;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Please try again.";
};
